<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 id="_idParaDest-4"><a id="_idTextAnchor003"></a>Bible Translations<br/>
<br/></h2>
<p class="body"><span class="pagebreak" id="pagexviii" title="xviii"></span></p>
<p class="body"><span class="pagebreak" id="pagexix" title="xix"></span></p>
<table class="no-lines">
<tbody><tr>
<td class="no-lines"><span class="small-caps">ESV</span></td>
<td class="no-lines">English Standard Version</td>
</tr>
<tr>
<td class="no-lines"><span class="small-caps">KJV</span></td>
<td class="no-lines">King James Version</td>
</tr>
<tr>
<td class="no-lines"><span class="small-caps">LXX</span></td>
<td class="no-lines">Septuagint</td>
</tr>
<tr>
<td class="no-lines"><span class="small-caps">NRSV</span></td>
<td class="no-lines">New Reivsed Standard Version</td>
</tr>
<tr>
<td class="no-lines">Vg</td>
<td class="no-lines">Vulgate</td>
</tr>
</tbody></table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bibletransl.vue?f5cee1c2